<template>
  <div class="container">
    <div class="service">
      <p class="title">请选择墓</p>
      <div>
        <div>
          <van-field
            required
            v-model="form.subscribeAddress"
            label="墓编号"
            placeholder="编号 或 **排**号"
          />
        </div>
      </div>
    </div>
    <div class="h10"></div>
    <div class="service">
      <p class="title">预约信息</p>
      <van-cell required title="选择预定时间" :value="form.subscribePredate" @click="show = true" />
      <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
      <van-calendar v-model="show" @confirm="onConfirm" />
    </div>
    <div class="h10"></div>
    <div class="service"><p class="title">服务项目</p></div>
    <div class="line"></div>
    <div class="service service-info">
      <ul class="service-info-list clearfix">
        <div v-for="(item, index) in goodsList" :key="index">
          <div class="service">
            <p class="title">{{item.proName}}</p>
          </div>
          <li>
            <div class="img" :style="'background-image:url(' + item.firstPhoto + ')'"></div>
            <div class="text">
              <p class="name">{{$properties(item['subscribeSpecs'],'label')}}</p>
            </div>
            <p class="price">￥{{item.price}}</p>
          </li>
        </div>
        <div class="line"></div>
        <li class="total">
          <p class="name">总计：</p>
          <p class="price">￥380</p>
        </li>
      </ul>
    </div>
    <div class="h10"></div>
    <div class="service">
      <p class="title">备注</p>
      <textarea
        rows="4"
        placeholder="您可以提供更详细的要求，以便更好地提供服务"
        class="textarea"
        v-model="form.subscribeMemo"
      ></textarea>
    </div>
    <div class="clear-foot"></div>
    <div class="foot-bar">
      <div class="info">需要支付 : <span class="price">￥380</span></div>
      <div class="btn" @click="submitPay()">创建订单</div>
    </div>
    <!---->
  </div>
</template>

<script>
export default {
  name: 'yudingfuwu1',
  data() {
    return {
      proImg: require('../../assets/shop.jpg'),
      // formData: {
      //   mobile: '',
      //   tongxing: '',
      //   xingming: '',
      //   shenfenzheng: '',
      //   date: ''
      // },
      form: {
        myId: this.$store.getters.userId,
        subscribeAddress: '',
        subscribePredate: '',
        subscribeMemo: '',
        goodsIds: []
      },
      goodsList: [],
      saveFlag: false,
      show: false,

      // 校验手机号码
      telRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
        {
          // 自定义校验规则
          validator: value => {
            return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
              value
            )
          },

          trigger: 'onBlur',
        },
      ],

      tongxingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],

      xingmingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],

      shenfenzhengRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],
    }
  },
  computed: {},
  created() {
    var params = this.$route.query
    this.form.goodsIds = params['goodsIds'].split(',')
    this.queryGoods(this.form.goodsIds)
  },
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onConfirm(date) {
      this.show = false
      this.form.subscribePredate = this.formatDate(date)
    },
    queryGoods(goodsIds){
      var that = this
      this.$queryAll(
        'ProGoods',
        { in_id: goodsIds },
        ['id', 'proName', 'price', 'firstPhoto', 'subscribeSpecs'],
        function(res) {
          that.$fill(that.goodsList, res['data'])
        }
      )
    },
    submitPay() {
      var that = this
      this.$submit('/api/order/addOrderWithSubscribe', this.form, function(res) {
        if (res['code'] === 1) {
          that.$router.push({ path: '/shop/payok', query: { orderNo: res['data']['orderNo'] } })
        }
      })
    },
  },
  watch: {},
}
</script>

<style>
.jiantou {
  position: absolute;
  right: 2rem;
  top: 16.3rem;
}
.container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.container {
  padding: 1rem;
  font-size: 1.6rem;
}
.service {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.service .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.h10 {
  width: 100%;
  height: 1rem;
}
.service-info {
  padding: 0 0 0.2rem;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}
.service {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.service .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.service ul.service-info-list li:last-child {
  border-bottom: 0;
}

.service ul.service-info-list li {
  min-height: 10rem;
  padding: 1rem 1.5rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  align-items: center;
}
.service ul.service-info-list li .img {
  width: 8rem;
  height: 8rem;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.service ul.service-info-list li .text {
  width: 18rem;
}
.text {
  position: relative;
  top: 1.7rem;
  left: 1.5rem;
  font-size: 1.6rem;
}
.service ul.service-info-list li .text .name {
  font-size: 1.6rem;
  color: #323232;
  line-height: 2.2rem;
}

.service .name {
  font-size: 1.4rem;
  color: #999;
}
.service ul.service-info-list li .price {
  font-weight: bolder;
  text-align: right;
}

.service .price {
  font-size: 1.3rem;
  color: #15a892;
}
.line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.service ul.service-info-list li.total {
  min-height: auto;
  text-align: right;
  justify-content: flex-end;
}

.service ul.service-info-list li:last-child {
  border-bottom: 0;
}

.service ul.service-info-list li {
  min-height: 10rem;
  padding: 1rem 1.5rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  align-items: center;
}
.service ul.service-info-list li.total .name {
  font-size: 1.4rem;
  color: #323232;
}

.service .name {
  font-size: 1.4rem;
  color: #999;
}
.service ul.service-info-list li .price {
  font-weight: bolder;
  text-align: right;
}

.service .price {
  font-size: 1.3rem;
  color: #15a892;
}
.clearfix:after {
  clear: both;
}
.clearfix:after,
.clearfix:before {
  content: ' ';
  display: table;
}
.service .textarea {
  width: 100%;
  font-size: 1.4rem;
  border: 1px solid #eee;
  padding: 0.5rem;
  margin-bottom: 1rem;
  display: inline-block;
  line-height: 2rem;
  height: 9rem;
  box-sizing: border-box;
}
.clear-foot {
  clear: both;
  height: 5rem;
}
.foot-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.6rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}
.foot-bar .info {
  padding-right: 1.7rem;
}
.foot-bar .info .price {
  color: #15a892;
  font-weight: bolder;
}
.foot-bar .btn {
  width: 13.5rem;
  font-size: 1.4rem;
  text-align: center;
  background-color: #15a892;
  color: #fff;
}
</style>
